import { Routes } from '@angular/router';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ThemeBuilderComponent } from './pages/theme-builder/theme-builder.component';
import { CoursesListComponent } from './pages/courses/courses-list/courses-list.component';
import { CreateCoursesComponent } from './pages/courses/create-courses/create-courses.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { LoginRedirectGuard } from './auth/login-redirect.guard';
import { MainMenusComponent } from './pages/menu/main-menus/main-menus.component';
import { UacActionsComponent } from './pages/menu/uac-actions/uac-actions.component';
import { UsersMenuPermissionsComponent } from './pages/menu/users-menu-permissions/users-menu-permissions.component';
import { UsersMenuListComponent } from './pages/menu/users-menu-list/users-menu-list.component';
import { ClientListComponent } from './pages/client/client-list/client-list.component';
import { ClientDetailEditComponent } from './pages/client/client-detail-edit/client-detail-edit.component';
import { ClientDetailViewComponent } from './pages/client/client-detail-view/client-detail-view.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { MasterDataComponent } from './components/master-data/master-data.component';
import { AssociatesComponent } from './pages/associates/associates.component';
import { CreateAssociateComponent } from './pages/associates/create-associate/create-associate.component';
import { CertificateComponent } from './components/certificate/certificate.component';




export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'courses', component: CoursesListComponent },
      { path: 'master-data', component: MasterDataComponent },
      { path: 'create-course/:type', component: CreateCoursesComponent },
      { path: 'edit-courses/:type/:id', component: CreateCoursesComponent },
{ path: 'theme-builder', component: ThemeBuilderComponent },
      { path: 'associates', component: AssociatesComponent },
      { path:'main-menus',component:MainMenusComponent },
      { path:'uac-actions',component:UacActionsComponent },

      { path:'users-menu',component:UsersMenuListComponent },
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'certificate', component: CertificateComponent },
      { path:'user-menu-permissions/:id',component:UsersMenuPermissionsComponent },

{path:'clients',children:[
        {path:'',component:ClientListComponent},
        {path:'create',component:ClientDetailEditComponent},
        {path:'edit/:id',component:ClientDetailEditComponent},
        {path:'view/:id',component:ClientDetailViewComponent},
      ]},
{path:'associates',children:[
        {path:'',component:AssociatesComponent},
        {path:'create-associate',component:CreateAssociateComponent},
        {path:'create-associate/:id',component:CreateAssociateComponent},
      ]},


    ]
  },
  { path: 'login', component: LoginComponent, canActivate: [LoginRedirectGuard] },
  { path: '**', redirectTo: '' }
];
